import React, { FunctionComponent } from 'react';
import ImageGallery from 'react-image-gallery';
import IsSmallOrMediumScreen from '../IsSmallOrMediumScreen/IsSmallOrMediumScreen';
import IsLargeScreen from '../IsLargeScreen/IsLargeScreen';
import {
  HereForYouSinceProposition,
  TrustPilotProposition,
  ZeroPlatformFeesProposition,
} from './Propositions';
import styles from './PropositionBar.scss';

export const PropositionBar: FunctionComponent = () => {
  return (
    <div className={styles.Container}>
      <IsLargeScreen>
        <div className={styles['Bar--DesktopBar']} data-qa="desktopBar">
          <ZeroPlatformFeesProposition />
          <TrustPilotProposition />
          <HereForYouSinceProposition />
        </div>
      </IsLargeScreen>
      <IsSmallOrMediumScreen>
        <ImageGallery
          infinite={true}
          showThumbnails={false}
          showNav={false}
          showBullets={false}
          showPlayButton={false}
          autoPlay={true}
          disableThumbnailScroll={true}
          showFullscreenButton={false}
          startIndex={1}
          additionalClass={styles.Bar}
          items={[
            {
              original: 'left',
              renderItem: () => <ZeroPlatformFeesProposition />,
            },
            {
              original: 'centre',
              renderItem: () => <TrustPilotProposition />,
            },
            {
              original: 'right',
              renderItem: () => <HereForYouSinceProposition />,
            },
          ]}
        />
      </IsSmallOrMediumScreen>
    </div>
  );
};
